.container {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-4);
}

.rangeSliderFilter {
  margin-top: var(--cxy-spacing-4);
}

.resetButton {
  align-self: center;
}
